"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authFailedTools = exports.authFailed = void 0;
const generated_1 = require("../../graphql/generated");
const clearMe = (client) => {
    const user = client.cache.readQuery({ query: generated_1.GetBasicUserDataDocument });
    if (user && user.me) {
        client.cache.evict({ id: client.cache.identify(user.me) });
    }
};
const declareApiNotReady = (client) => {
    client.cache.writeQuery({ query: generated_1.IsApiReadyDocument, data: { apiReady: false }, overwrite: true });
};
const authFailed = (context, _event) => (_callback) => {
    const snapAuthUpdatedEvent = new CustomEvent("SNAP_AUTH_UPDATED", { detail: "authFailed" });
    window.dispatchEvent(snapAuthUpdatedEvent);
    if (context.apolloClient) {
        exports.authFailedTools.clearMe(context.apolloClient);
        context.apolloClient.cache.gc();
        exports.authFailedTools.declareApiNotReady(context.apolloClient);
        context.apolloClient.refetchQueries({ include: "active" });
    }
};
exports.authFailed = authFailed;
exports.authFailedTools = {
    clearMe,
    declareApiNotReady,
};
